import React from "react"
import { useEffect, useState } from "react"
import clsx from "clsx"
import AnnouncementHeader from "./AnnouncementHeader"
import MenuBar from "./MenuBar/MenuBar"
import { useIsMobile } from "@components/helpers/useWindowSize"

const Header = () => {
	const isMobile = useIsMobile()
	const [lastScrollY, setLastScrollY] = useState(0)
	const [hidden, setHidden] = useState(false)
	const threshold = 480 // adjust this as needed

	useEffect(() => {
		const handleScroll = () => {
			const currentScrollY =
				window.pageYOffset || document.documentElement.scrollTop // for iOS proof value catching

			if (Math.abs(currentScrollY - lastScrollY) < 5) return

			if (currentScrollY > lastScrollY && currentScrollY > threshold) {
				setHidden(true)
			} else if (currentScrollY < lastScrollY) {
				setHidden(false) // shows whole header upon scroll up
			}

			setLastScrollY(currentScrollY)
		}

		window.addEventListener("scroll", handleScroll, { passive: true })
		return () => window.removeEventListener("scroll", handleScroll)
	}, [lastScrollY])

	return (
		<header
			className={clsx(
				"fixed top-0 left-0 w-full bg-white z-[51] shadow-sm transition-transform duration-300 ease-in-out will-change-transform backface-hidden",
				isMobile && hidden ? "-translate-y-[40px]" : "translate-y-0"
			)}
		>
			<AnnouncementHeader />
			<MenuBar />
		</header>
	)
}

export default Header
